/* =========================================================
   ZEPTO STYLE OPTIONS POPUP
   Opens when a product card "N Options" button is clicked and the theme
   setting "When click Select options button" is set to the Zepto popup.
   Desktop: centred modal. Mobile: bottom sheet.
   ========================================================= */
(function () {
  'use strict';
  if (window.ZeptoOptionsLoaded) return;
  window.ZeptoOptionsLoaded = true;
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var LABELS = Object.assign(
    {
      add: 'ADD',
      soldOut: 'Sold out',
      save: 'Save',
      loading: 'Loading options',
      error: 'Could not load the options. Open the product page instead.',
      close: 'Close'
    },
    window.ZeptoOptionsLabels || {}
  );
  var cache = {};
  var root = null;
  var sheet = null;
  var titleEl = null;
  var listEl = null;
  var currentProduct = null;
  var lastFocused = null;
  var openVersion = 0;
  /* ---------- helpers ---------- */
  function money(cents) {
    return window.ZeptoATC && window.ZeptoATC.money
      ? window.ZeptoATC.money(cents)
      : (cents / 100).toFixed(2);
  }
  // Optimistic overrides so the stepper reacts instantly, like the Zepto app
  var pending = {};
  function cartQtyOf(variantId) {
    return window.ZeptoATC && window.ZeptoATC.quantityOf
      ? window.ZeptoATC.quantityOf(variantId)
      : 0;
  }
  function qtyOf(variantId) {
    var held = pending[variantId];
    return held ? held.qty : cartQtyOf(variantId);
  }
  function sized(url, width) {
    if (!url) return '';
    var full = url.indexOf('//') === 0 ? 'https:' + url : url;
    return full + (full.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }
  // Variant image, falling back to the product image when the variant has none
  function imageFor(product, variant) {
    if (variant.featured_image && variant.featured_image.src) return variant.featured_image.src;
    if (variant.featured_media && variant.featured_media.preview_image) {
      return variant.featured_media.preview_image.src;
    }
    if (product.featured_image) return product.featured_image;
    if (product.images && product.images.length) return product.images[0];
    return '';
  }
  function unitPriceOf(variant) {
    if (!variant.unit_price || !variant.unit_price_measurement) return '';
    var m = variant.unit_price_measurement;
    var ref = m.reference_value && m.reference_value !== 1 ? m.reference_value : '';
    return money(variant.unit_price) + '/' + ref + (m.reference_unit || '');
  }
  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  var closeIcon =
    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>';
  var plusIcon =
    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 5.5v13M5.5 12h13" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>';
  var minusIcon =
    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5.5 12h13" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>';
  /* ---------- build the popup once ---------- */
  function ensureRoot() {
    if (root) return root;
    root = document.createElement('div');
    root.className = 'zepto-opt';
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-label', 'Product options');
    root.innerHTML =
      '<div class="zepto-opt__backdrop" data-zepto-close></div>' +
      '<div class="zepto-opt__sheet">' +
      '<button type="button" class="zepto-opt__close" data-zepto-close aria-label="' + esc(LABELS.close) + '">' + closeIcon + '</button>' +
      '<h2 class="zepto-opt__title" data-zepto-title></h2>' +
      '<div class="zepto-opt__list" data-zepto-list></div>' +
      '</div>';
    document.body.appendChild(root);
    sheet = root.querySelector('.zepto-opt__sheet');
    titleEl = root.querySelector('[data-zepto-title]');
    listEl = root.querySelector('[data-zepto-list]');
    root.addEventListener('click', function (e) {
      var target = e.target instanceof Element ? e.target : null;
      if (!target) return;
      if (target.closest('[data-zepto-close]')) {
        e.preventDefault();
        close();
        return;
      }
      var addBtn = target.closest('[data-zepto-opt-add]');
      if (addBtn) {
        e.preventDefault();
        changeQty(addBtn.closest('[data-variant]'), 1, true);
        return;
      }
      var plus = target.closest('[data-zepto-opt-plus]');
      if (plus) {
        e.preventDefault();
        changeQty(plus.closest('[data-variant]'), 1, false);
        return;
      }
      var minus = target.closest('[data-zepto-opt-minus]');
      if (minus) {
        e.preventDefault();
        changeQty(minus.closest('[data-variant]'), -1, false);
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) close();
    });
    if (window.ZeptoATC && window.ZeptoATC.subscribe) {
      window.ZeptoATC.subscribe(function () {
        if (root.classList.contains('is-open')) refreshActions();
      });
    }
    return root;
  }
  /* ---------- open / close ---------- */
  function open(handle, fallbackUrl, fallbackTitle) {
    ensureRoot();
    lastFocused = document.activeElement;
    currentProduct = null;
    var version = ++openVersion;
    titleEl.textContent = fallbackTitle || '';
    listEl.innerHTML = '<div class="zepto-opt__loading">' + esc(LABELS.loading) + '</div>';
    root.classList.add('is-open');
    document.documentElement.classList.add('zepto-opt-open');
    Promise.all([load(handle), window.ZeptoATC ? window.ZeptoATC.refresh() : Promise.resolve()])
      .then(function (results) {
        if (version !== openVersion) return;
        var product = results[0];
        currentProduct = product;
        titleEl.textContent = product.title;
        render(product);
      })
      .catch(function () {
        if (version !== openVersion) return;
        listEl.innerHTML =
          '<div class="zepto-opt__error">' +
          esc(LABELS.error) +
          (fallbackUrl ? ' <a href="' + esc(fallbackUrl) + '">' + esc(fallbackTitle || '') + '</a>' : '') +
          '</div>';
      });
  }
  function close() {
    if (!root) return;
    openVersion += 1;
    root.classList.remove('is-open');
    document.documentElement.classList.remove('zepto-opt-open');
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }
  function load(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch(ROOT + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('not found');
        return r.json();
      })
      .then(function (product) {
        cache[handle] = product;
        return product;
      });
  }
  /* ---------- rendering ---------- */
  function render(product) {
    var rows = product.variants
      .map(function (variant) {
        var image = sized(imageFor(product, variant), 160);
        var label = variant.title === 'Default Title' ? product.title : variant.title;
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        var unit = unitPriceOf(variant);
        return (
          '<div class="zepto-opt__row' + (onSale ? ' has-save' : '') + '" data-variant="' + variant.id + '">' +
          (onSale
            ? '<span class="zepto-opt__save">' +
              esc(LABELS.save) + ' ' + money(variant.compare_at_price - variant.price) +
              '</span>'
            : '') +
          '<div class="zepto-opt__thumb">' +
          (image ? '<img src="' + esc(image) + '" alt="' + esc(label) + '" loading="lazy" width="80" height="80">' : '') +
          '</div>' +
          '<div class="zepto-opt__label">' + esc(label) + '</div>' +
          '<div class="zepto-opt__prices">' +
          '<div class="zepto-opt__price-row">' +
          '<span class="zepto-opt__price">' + money(variant.price) + '</span>' +
          (onSale ? '<s class="zepto-opt__compare">' + money(variant.compare_at_price) + '</s>' : '') +
          '</div>' +
          (unit ? '<div class="zepto-opt__unit">' + esc(unit) + '</div>' : '') +
          '</div>' +
          '<div class="zepto-opt__action" data-zepto-action>' + actionMarkup(variant) + '</div>' +
          '</div>'
        );
      })
      .join('');
    listEl.innerHTML = rows;
  }
  function actionMarkup(variant) {
    if (!variant.available) {
      return '<button type="button" class="zepto-opt__add is-soldout" disabled>' + esc(LABELS.soldOut) + '</button>';
    }
    var qty = qtyOf(variant.id);
    if (qty > 0) {
      return (
        '<div class="zepto-opt__qty">' +
        '<button type="button" class="zepto-opt__step" data-zepto-opt-minus aria-label="Decrease">' + minusIcon + '</button>' +
        '<span class="zepto-opt__count">' + qty + '</span>' +
        '<button type="button" class="zepto-opt__step" data-zepto-opt-plus aria-label="Increase">' + plusIcon + '</button>' +
        '</div>'
      );
    }
    return '<button type="button" class="zepto-opt__add" data-zepto-opt-add>' + esc(LABELS.add) + '</button>';
  }
  function variantById(id) {
    if (!currentProduct) return null;
    for (var i = 0; i < currentProduct.variants.length; i++) {
      if (currentProduct.variants[i].id === Number(id)) return currentProduct.variants[i];
    }
    return null;
  }
  function refreshActions() {
    if (!currentProduct || !listEl) return;
    listEl.querySelectorAll('[data-variant]').forEach(function (row) {
      var variant = variantById(row.dataset.variant);
      if (!variant) return;
      var holder = row.querySelector('[data-zepto-action]');
      var next = actionMarkup(variant);
      if (holder && holder.innerHTML.trim() !== next.trim()) holder.innerHTML = next;
    });
  }
  function showCartError(message) {
    if (!sheet) return;
    var error = sheet.querySelector('[data-zepto-cart-error]');
    if (!error) {
      error = document.createElement('div');
      error.className = 'zepto-opt__error';
      error.setAttribute('data-zepto-cart-error', '');
      error.setAttribute('role', 'alert');
      sheet.appendChild(error);
    }
    error.textContent = message;
    error.hidden = !message;
  }
  /* ---------- cart actions ---------- */
  function changeQty(row, delta, isFirstAdd) {
    if (!row) return;
    if (!window.ZeptoATC) {
      showCartError('Cart could not load. Please refresh the page and try again.');
      return;
    }
    var variantId = Number(row.dataset.variant);
    if (Object.keys(pending).length) return;
    var variant = variantById(variantId);
    if (!variant || !variant.available) return;
    var max = variant && variant.inventory_management && variant.inventory_policy !== 'continue' &&
      typeof variant.inventory_quantity === 'number' && Number.isFinite(variant.inventory_quantity)
      ? Math.max(1, variant.inventory_quantity)
      : 99;
    var next = Math.max(0, Math.min(max, qtyOf(variantId) + delta));
    // 1. paint the new quantity straight away
    var held = pending[variantId] || {};
    held.qty = next;
    held.open = false;
    held.addons = held.addons || isFirstAdd;
    held.version = openVersion;
    pending[variantId] = held;
    refreshActions();
    // 2. send it after a short pause, so fast taps become one request
    clearTimeout(held.timer);
    held.timer = setTimeout(function () { commit(variantId, row); }, (window.ZeptoATC.config || {}).debounce || 320);
  }
  function CONFIG_OPEN_DRAWER() {
    return !!(window.ZeptoATC.config && window.ZeptoATC.config.openDrawerFromOptions === true);
  }
  function commit(variantId, row) {
    var held = pending[variantId];
    if (!held || held.saving) return;
    held.saving = true;
    showCartError('');
    var target = held.qty;
    var shouldOpen = held.open;
    var showAddons = held.addons && target > 0;
    var version = held.version;
    row.classList.add('is-loading');
    row.classList.remove('is-error');
    var line = window.ZeptoATC.lineOf(variantId);
    var request = line
      ? window.ZeptoATC.change(line.key, target)
      : (target > 0 ? window.ZeptoATC.add(variantId, target) : Promise.resolve());
    request
      .then(function () { return window.ZeptoATC.refresh(); })
      .then(function (freshCart) {
        if (!freshCart) throw new Error('Unable to confirm your bag. Please refresh before trying again.');
        delete pending[variantId];
        // the drawer stays shut by default so it never covers the sheet
        window.ZeptoATC.notify(false);
        refreshActions();
        if (showAddons && version === openVersion) {
          close();
          return window.ZeptoATC.afterAdd({ productId: currentProduct.id, title: currentProduct.title, source: lastFocused });
        }
      })
      .catch(function (err) {
        delete pending[variantId];
        row.classList.add('is-error');
        showCartError(err.message || 'Unable to update cart. Please try again.');
        console.warn('[zepto-options]', err.message);
        window.ZeptoATC.refresh().then(refreshActions);
        setTimeout(function () { row.classList.remove('is-error'); }, 2500);
      })
      .finally(function () { row.classList.remove('is-loading'); });
  }
  /* ---------- open from any card button ---------- */
  document.addEventListener(
    'click',
    function (e) {
      var target = e.target instanceof Element ? e.target : null;
      if (!target) return;
      var btn = target.closest('[data-zepto-options]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      open(btn.dataset.productHandle, btn.dataset.productUrl, btn.dataset.productTitle);
    },
    true
  );
  window.ZeptoOptions = { open: open, close: close };
  console.info('[zepto-options] JS loaded');
})();
/* =========================================================
   ZEPTO VIEW CART -> MINIMOG CART DRAWER BRIDGE
   ADDITIVE PATCH ONLY — original code above is unchanged.
   What it does:
   - Intercepts only the "View Cart" control inside a popup/toast.
   - Prevents navigation to /cart.
   - Closes the Zepto options popup first when it is open.
   - Opens/refreshed Minimog's side cart drawer.
   - Uses Minimog's public cart:refresh event first, with an API fallback
     for older theme versions.
   ========================================================= */
(function () {
  'use strict';
  if (window.ZeptoViewCartDrawerBridgeLoaded) return;
  window.ZeptoViewCartDrawerBridgeLoaded = true;
  function cleanText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }
  function isCartUrl(element) {
    if (!element || element.tagName !== 'A') return true;
    var href = element.getAttribute('href') || '';
    if (!href || href === '#') return true;
    try {
      var url = new URL(href, window.location.href);
      var path = url.pathname.replace(/\/+$/, '');
      var shopRoot =
        window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root.replace(/\/+$/, '')
          : '';
      return path === '/cart' || path === shopRoot + '/cart';
    } catch (e) {
      return /(^|\/)cart\/?(?:[?#].*)?$/.test(href);
    }
  }
  function isPopupViewCart(element) {
    var clickable = element && element.closest
      ? element.closest('a, button, [role="button"]')
      : null;
    if (!clickable || clickable.hasAttribute('data-za-view-cart')) return null;
    if (cleanText(clickable.textContent) !== 'view cart') return null;
    if (!isCartUrl(clickable)) return null;
    // Keep the bridge limited to toast/popup UI so a normal page "View Cart"
    // link is left untouched.
    var node = clickable;
    for (var i = 0; node && i < 7; i += 1, node = node.parentElement) {
      var role = cleanText(node.getAttribute && node.getAttribute('role'));
      if (role === 'alert' || role === 'status' || role === 'dialog') return clickable;
      var signature = cleanText(
        (node.id || '') + ' ' +
        (typeof node.className === 'string' ? node.className : '') + ' ' +
        (node.getAttribute && node.getAttribute('data-type') || '')
      );
      if (/(toast|snackbar|notif|notify|notification|alert|success|cart[-_ ]?message|message[-_ ]?cart|popup)/i.test(signature)) {
        return clickable;
      }
      if (window.getComputedStyle) {
        var style = window.getComputedStyle(node);
        if (style && (style.position === 'fixed' || style.position === 'sticky')) {
          return clickable;
        }
      }
    }
    return null;
  }
  function closeZeptoOptionsIfOpen() {
    try {
      if (window.ZeptoOptions && typeof window.ZeptoOptions.close === 'function') {
        window.ZeptoOptions.close();
      }
    } catch (e) {
      // Do not block the cart drawer if another popup fails to close.
    }
  }
  function openCartDrawer() {
    closeZeptoOptionsIfOpen();
    if (window.ZeptoAddons) window.ZeptoAddons.close();
    if (window.ZeptoATC) window.ZeptoATC.openDrawer();
  }
  document.addEventListener(
    'click',
    function (event) {
      var target = event.target instanceof Element ? event.target : null;
      if (!target) return;
      var viewCart = isPopupViewCart(target);
      if (!viewCart) return;
      // Stop the popup link from navigating to /cart.
      event.preventDefault();
      event.stopPropagation();
      openCartDrawer();
    },
    true
  );
})();
